<div *ngIf="loading || processingLogin"  class="dds__modal dds__loading-modal dds__d-block" tabindex="-1" role="dialog"  >
  <div class="dds__modal-dialog" role="document">
    <div class="dds__modal-content">
      <div class="dds__modal-body dds__text-center">
        <div class="dds__mb-3" id="modalId">
          <div class="dds__progress-bar">
            <div class="dds__progress-bar-standard dds__progress-bar-striped dds__progress-bar-animated"
              role="progressbar" data-showtext="true"></div>
          </div>
        </div>
        <p>Processing... Please wait.</p>
      </div>
    </div>
  </div>
  </div>
  <div *ngIf="!processingLogin" class="middle-container">
    <section style="overflow: hidden;">
      <div class="dds__row">
        <div class="dds__col-12 dds__text-white"
          style="background-image: url('assets/image/Home Page/KBSearchBackGround.png'); height: 350px; background-size: cover">
          <div class="dds__h-25 dds__d-flex dds__align-items-center dds__justify-content-center dds__mt-5">
            <div class="dds__h1">What can we help you with?</div>
          </div>
          <div class="dds__h-25 dds__d-flex dds__align-items-center dds__justify-content-center">
            <div class="dds__filter-keyword dds__w-50" data-toggle="dds__filter-keyword">
              <!-- @*<label id="filter-keyword-label" for="keyword-input" aria-label="Keyword Filtering">Keyword:</label>*@ -->
              <div class="dds__filter-container">
                <input (keyup.enter)="applyFilter()" id="keyword-input" #searchText aria-labelledby="filter-keyword-label" type="text"
                  class="dds__form-control dds__filter-input" aria-label="keyword-filter"
                  placeholder="Search using any keyword or phrase" style="padding:9px;">
                <button type="submit" class="dds__btn dds__btn-primary dds__filter-btn" (click)="applyFilter();"
                  aria-label="filter-add">
                  <svg class="dds__icon-svg" tabindex="-1" focusable="false">
                    <use xlink:href="#dds__search"></use>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div class="dds__container">
        <div class="dds__row">
        </div>
        <hr class="dds__primary_divider dds__mt-0" />
        <div class="dds__row" style="overflow: auto;" >
          <div id="articleContainer"  class="dds__col-sm-12 dds__col-md-12 dds__col-lg-12 dds__col-xl-12 customTable">
            <table mat-table [dataSource]="dataSource" style="width: 100%; overflow-x: auto; table-layout:fixed;" data-table="dds__table"
              class="dds__table dds__table-hover dds__table-cmplx dds__table-responsive-lg" tabindex="0" id="dtCIO"
              aria-label="CIO Fields Table; In this table it shows all CIO Fields which are associated to this account.">
              <!-- Aricle Column -->
              <ng-container matColumnDef="ArticleTitle">
                <th mat-header-cell *matHeaderCellDef class="dds__d-none" style="color:#006bbd;">
                  <h3 class="dds__h3 dds__my-3" tabindex="0"> Article Name</h3>
                </th>
                <td mat-cell *matCellDef="let element"><a
                  [routerLink]="'/'+ element.ArticlePath.toLowerCase().split(' ').join('_')">{{element.ArticleTitle}}</a></td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator class="mat-paginator" [hidden]="rowSize<=0" [pageSizeOptions]="[5, 10, 20]"
              showFirstLastButtons aria-label="Select page of articles">
            </mat-paginator>
            <ng-container *ngIf="rowSize<=0">
              <div style="width:100%;text-align:center;color: red;">
                <p>No Articles Found!</p>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </section>
</div>
